module.exports = __webpack_public_path__ + "img/rebalance.459cc2d1.svg";